import { API_ROOT } from '../../config/config'
import { doDelete, doGet, doPost, doPut } from './utils'

export const getOrganization = (id) => {
  const url = `${API_ROOT}/proposal/${id}/project/co-organization/item`
  return doGet(url)
}

export const getOrganizationItem = (id, itemId) => {
  const url = `${API_ROOT}/proposal/${id}/project/co-organization/item/${itemId}`
  return doGet(url)
}

export const saveOrganization = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/project/co-organization/item`
  return doPost(url, request)
}

export const updateOrganization = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/project/co-organization/item/${request.id}`
  return doPut(url, request)
}

export const deleteOrganization = (id, itemId) => {
  const url = `${API_ROOT}/proposal/${id}/project/co-organization/item/${itemId}`
  return doDelete(url)
}
